var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/status-reply-mentions.tsx";
import React from 'react';
import { FormattedList, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { openModal } from 'soapbox/actions/modals';
import HoverRefWrapper from 'soapbox/components/hover-ref-wrapper';
import HoverStatusWrapper from 'soapbox/components/hover-status-wrapper';
import { useAppDispatch } from 'soapbox/hooks';

const StatusReplyMentions = _ref => {
  let {
    status,
    hoverable = true
  } = _ref;
  const dispatch = useAppDispatch();

  const handleOpenMentionsModal = e => {
    e.stopPropagation();
    const account = status.account;
    dispatch(openModal('MENTIONS', {
      username: account.acct,
      statusId: status.id
    }));
  };

  if (!status.in_reply_to_id) {
    return null;
  }

  const to = status.mentions; // The post is a reply, but it has no mentions.
  // Rare, but it can happen.

  if (to.size === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "reply-mentions",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reply_mentions.reply_empty",
      defaultMessage: "Replying to post",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 9
      }
    }));
  } // The typical case with a reply-to and a list of mentions.


  const accounts = to.slice(0, 2).map(account => {
    const link = /*#__PURE__*/React.createElement(Link, {
      to: "/@".concat(account.acct),
      className: "reply-mentions__account",
      onClick: e => e.stopPropagation(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 7
      }
    }, "@", account.username);

    if (hoverable) {
      return /*#__PURE__*/React.createElement(HoverRefWrapper, {
        key: account.id,
        accountId: account.id,
        inline: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 9
        }
      }, link);
    } else {
      return link;
    }
  }).toArray();

  if (to.size > 2) {
    accounts.push( /*#__PURE__*/React.createElement("span", {
      key: "more",
      className: "hover:underline cursor-pointer",
      role: "button",
      onClick: handleOpenMentionsModal,
      tabIndex: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "reply_mentions.more",
      defaultMessage: "{count} more",
      values: {
        count: to.size - 2
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 9
      }
    })));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "reply-mentions",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "reply_mentions.reply.hoverable",
    defaultMessage: "<hover>Replying to</hover> {accounts}",
    values: {
      accounts: /*#__PURE__*/React.createElement(FormattedList, {
        type: "conjunction",
        value: accounts,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 21
        }
      }),
      hover: children => {
        if (hoverable) {
          return /*#__PURE__*/React.createElement(HoverStatusWrapper, {
            statusId: status.in_reply_to_id,
            inline: true,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 85,
              columnNumber: 17
            }
          }, /*#__PURE__*/React.createElement("span", {
            key: "hoverstatus",
            className: "hover:underline cursor-pointer",
            role: "presentation",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 86,
              columnNumber: 19
            }
          }, children));
        } else {
          return children;
        }
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 7
    }
  }));
};

export default StatusReplyMentions;